import { useCategoryList } from "@hooks/inventory/settings/useCategoryList";
import { CategoryForm, CategoryListTable } from "./component";

export default function Category({
  handleScrollToTop,
}: {
  handleScrollToTop: () => void;
}) {
  const { handleQuery, settingsCategoryState } = useCategoryList();
  return (
    <>
      <CategoryForm settingsCategoryState={settingsCategoryState} />
      <CategoryListTable
        handleScrollToTop={handleScrollToTop}
        handleQuery={handleQuery}
        settingsCategoryState={settingsCategoryState}
      />
    </>
  );
}
